// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Cart__wrap___350xY","long":"Cart__long___wPcF2","fakeItems":"Cart__fakeItems___2o6St","sticky":"Cart__sticky___1oA8h colors__bg-secondary___2iAxQ"};